import React from "react";
import { withRouter } from "../_shared/withRouter";
import WelcomeComponent from "../template/user/welcomeComponent";

const UserWelcome = () => {
  return <WelcomeComponent roleType={"user"} role={"3"} />;
};

export default withRouter(UserWelcome);
